import { render, staticRenderFns } from "./DashboardRightTable.vue?vue&type=template&id=5a4cec90&scoped=true&"
import script from "./DashboardRightTable.vue?vue&type=script&lang=js&"
export * from "./DashboardRightTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRightTable.vue?vue&type=style&index=0&id=5a4cec90&prod&lang=scss&scoped=true&"
import style1 from "./DashboardRightTable.vue?vue&type=style&index=1&id=5a4cec90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cec90",
  null
  
)

export default component.exports